import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { invoiceTemplateQueryOptions } from './useInvoiceTemplate';

export const useDeleteInvoiceTemplate = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetchJson(`/invoice-templates/${id}`, {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      queryClient.removeQueries(invoiceTemplateQueryOptions(id));

      return queryClient.invalidateQueries({ queryKey: QueryKeys.invoiceTemplates.index.root });
    },
  });
};
